import { Component } from '@angular/core';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import moment from 'moment';
import { AvataresService } from 'src/app/shared/service/avatares/avatares.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-home-profile',
  templateUrl: './home-profile.component.html',
  styleUrl: './home-profile.component.css',
})
export class HomeProfileComponent {
  selectedAvatar!: string; // Avatar predeterminado (Juan)
  isModalOpen: boolean = false;
  profileForm!: FormGroup;

  avatars: string[] = [];
  options: string[] = [
    'Argentina',
    'Bolivia',
    'Brasil',
    'Canadá',
    'Chile',
    'Costa Rica',
    'Cuba',
    'Ecuador',
    'El Salvador',
    'España',
    'Estados Unidos',
    'Guatemala',
    'Honduras',
    'México',
    'Nicaragua',
    'Panamá',
    'Paraguay',
    'Perú',
    'República Dominicana',
    'Uruguay',
    'Venezuela',
  ];
  departments: any[] = [];
  cities: any[] = [];

  countries = [
    { code: '57', name: 'Colombia' },
    { code: '54', name: 'Argentina' },
    { code: '52', name: 'México' },
    { code: '1', name: 'Estados Unidos' },
    { code: '34', name: 'España' },
    { code: '55', name: 'Brasil' },
    { code: '49', name: 'Alemania' },
  ];

  departmentData: Record<string, string[]> = {
    '57': ['Antioquia', 'Cundinamarca', 'Valle del Cauca'],
    '54': ['Buenos Aires', 'Córdoba', 'Mendoza'],
    '52': ['Jalisco', 'Nuevo León', 'CDMX'],
    '1': ['California', 'Texas', 'Florida'],
    '34': ['Madrid', 'Cataluña', 'Andalucía'],
    '55': ['São Paulo', 'Rio de Janeiro', 'Bahia'],
    '49': ['Baviera', 'Berlín', 'Renania del Norte-Westfalia'],
  };

  cityData: Record<string, string[]> = {
    Antioquia: ['Medellín', 'Envigado', 'Bello', 'Itagüí', 'Apartadó', 'Turbo', 'La Ceja'],
    Cundinamarca: ['Bogotá', 'Soacha', 'Zipaquirá', 'Chía', 'Fusagasugá', 'Girardot', 'La Calera'],
    'Valle del Cauca': ['Cali', 'Buenaventura', 'Palmira', 'Tuluá', 'Jamundí', 'Buga', 'Yumbo'],
    'Buenos Aires': ['La Plata', 'Mar del Plata', 'Quilmes'],
    Córdoba: ['Villa Carlos Paz', 'Río Cuarto', 'San Francisco'],
    Mendoza: ['Godoy Cruz', 'San Rafael', 'Las Heras'],
    Jalisco: ['Guadalajara', 'Zapopan', 'Puerto Vallarta'],
    'Nuevo León': ['Monterrey', 'San Pedro', 'Guadalupe'],
    CDMX: ['Benito Juárez', 'Coyoacán', 'Tlalpan'],
    California: ['Los Ángeles', 'San Francisco', 'San Diego'],
    Texas: ['Houston', 'Dallas', 'Austin'],
    Florida: ['Miami', 'Orlando', 'Tampa'],
    Madrid: ['Madrid', 'Alcalá de Henares', 'Getafe'],
    Cataluña: ['Barcelona', 'Girona', 'Tarragona'],
    Andalucía: ['Sevilla', 'Málaga', 'Granada'],
    'São Paulo': ['São Paulo', 'Campinas', 'Santos'],
    'Rio de Janeiro': ['Rio de Janeiro', 'Niterói', 'Petrópolis'],
    Bahia: ['Salvador', 'Feira de Santana', 'Ilhéus'],
    Baviera: ['Múnich', 'Núremberg', 'Augsburgo'],
    Berlín: ['Berlín'],
    'Renania del Norte-Westfalia': ['Colonia', 'Düsseldorf', 'Dortmund'],
  };

  constructor(
    private analitycs: AnalitycsService,
    private avataresService: AvataresService,
    private fb: FormBuilder,
  ) {
    // do nothing
  }
  ngOnInit() {
    this.analitycs.logEvent('InitialHomeProfile', {
      view: 'Home-profile',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.selectedAvatar = localStorage.getItem('selectedAvatar') ?? 'assets/images/juan1.png';

    this.avataresService.getAvatares().subscribe((data) => {
      // Extraemos solo las URLs (img_avatar) de cada objeto
      this.avatars = data.map((avatar) => avatar.img_avatar);
      console.log(this.avatars);
    });
    this.profileForm = this.fb.group({
      name: ['', Validators.required],
      lastname: ['', Validators.required],
      country: ['', Validators.required],
      department: ['', Validators.required],
      city: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  openAvatarModal() {
    this.analitycs.logEvent('OPEN_MODAL', {
      view: 'edit-profile',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.isModalOpen = true;
  }

  closeAvatarModal() {
    this.analitycs.logEvent('CLOSE_MODAL', {
      view: 'HOME-profile',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.isModalOpen = false;
  }

  selectAvatar(avatar: string) {
    this.analitycs.logEvent('SELECT_AVATAR', {
      view: 'HOME-profile',
      action: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.selectedAvatar = avatar;
    localStorage.setItem('selectedAvatar', avatar);
    // this.closeAvatarModal();
    // Cierra el modal después de seleccionar
  }
  onCountryChange(event: any) {
    const selectedCountryCode = event.target.value;

    this.departments = this.departmentData[selectedCountryCode] ? this.departmentData[selectedCountryCode].map((dep) => ({ name: dep })) : [];

    this.profileForm.get('department')?.enable();
    this.profileForm.get('department')?.setValue(''); // Reinicia el departamento seleccionado
    this.cities = []; // Limpia las ciudades al cambiar de país
  }

  onDepartmentChange(event: any) {
    const selectedDepartment = event.target.value;
    if (selectedDepartment === 'Antioquia') {
      this.cities = [{ name: 'Medellín' }, { name: 'Envigado' }];
    } else if (selectedDepartment === 'Buenos Aires') {
      this.cities = [{ name: 'La Plata' }, { name: 'Mar del Plata' }];
    }

    this.profileForm.get('city')?.enable();
  }

  submitForm() {
    if (this.profileForm.valid) {
      Swal.fire({
        icon: 'success',
        title: 'Perfil actualizado',
        text: 'Tu perfil se ha actualizado correctamente.',
      });
    } else {
      Swal.fire({
        icon: 'question',
        title: 'Avatar',
        text: 'Puedes seleccionar el avatar que mas te guste😎.',
      });
    }
  }
}
